{
	"active": "Active",
	"app_fallbacks": {
		"error": {
			"description": "An unexpected error occurred while rendering this page. You can try again, or head back to a working area of the app.",
			"title": "Something went wrong."
		},
		"go_back": "Go back",
		"go_home": "Go home",
		"loading": "Loading",
		"not_found": {
			"description": "The page you're looking for doesn't exist or may have moved. Head back to a working area of the app.",
			"title": "Page not found."
		},
		"permission_error": {
			"description": "You don't have the permissions to access this page.",
			"title": "Access denied"
		},
		"try_again": "Try again"
	},
	"app_sidebar": {
		"menu": {
			"home": "Home",
			"logout": "Log out",
			"profile": "Settings"
		},
		"user_menu": {
			"open": "Open user menu"
		}
	},
	"back": "Back",
	"banned": "Banned",
	"cancel": "Cancel",
	"change_password": "Change password",
	"created_at": "Created at",
	"delete_account": "Delete account",
	"deleted": "Deleted",
	"detail_section": {
		"error": "Couldn't load this section."
	},
	"disabled": "Disabled",
	"edit": "Edit",
	"email": "Email",
	"email_verified_on": "Verified on {{date}}",
	"enabled": "Enabled",
	"name": "Name",
	"new_password": "New password",
	"password": "Password",
	"password_min": "Password must be at least 12 characters.",
	"remove": "Remove",
	"save": "Save",
	"unverified": "Unverified",
	"verified": "Verified"
}
